import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { categoryApi } from '../../shared/api/endpoints';
import './SubCategoryCarousel.css';

export default function SubCategoryCarousel() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const trackRef = useRef(null);

  useEffect(() => {
    categoryApi
      .uniqueSubs()
      .then((res) => setItems(res.data.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoaded(true));
  }, []);

  useEffect(() => {
    const el = trackRef.current;
    if (!el || items.length < 4) return undefined;
    let raf;
    let x = 0;
    const step = () => {
      x += 0.45;
      if (x >= el.scrollWidth / 2) x = 0;
      el.scrollLeft = x;
      raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    const pause = () => cancelAnimationFrame(raf);
    const resume = () => {
      raf = requestAnimationFrame(step);
    };
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
      el.removeEventListener('touchstart', pause);
    };
  }, [items]);

  if (!loaded || items.length === 0) return null;

  const useCarousel = items.length > 4;
  const loop = useCarousel ? [...items, ...items] : items;

  return (
    <section className="section subcat section--lite">
      <div className="container subcat__intro">
        <div>
          <p className="section-eyebrow">Explore</p>
          <h2 className="section-title">Styles in motion</h2>
          <p className="section-sub">Swipe through the atelier edits — each frame opens a world.</p>
        </div>
        <Link to="/products" className="subcat__all">
          Shop all →
        </Link>
      </div>
      <div className={`subcat__track${useCarousel ? ' is-carousel' : ''}`} ref={trackRef}>
        {loop.map((item, idx) => (
          <motion.div
            key={`${item._id}-${idx}`}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: (idx % 8) * 0.04 }}
          >
            <Link
              to={`/products?subCategory=${item._id}${item.parent ? `&category=${item.parent._id || item.parent}` : ''}`}
              className={`subcat__card subcat__card--${(idx % 4) + 1}`}
            >
              <div
                className="subcat__img"
                style={{
                  backgroundImage: item.image
                    ? `url(${item.image})`
                    : 'linear-gradient(145deg, #fce4f0, #e8f4ff, #fff5eb)',
                }}
              />
              <div className="subcat__overlay">
                <span className="subcat__index">{String((idx % items.length) + 1).padStart(2, '0')}</span>
                <strong>{item.name}</strong>
                <em>Enter edit</em>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
